import apiClient from '../utils/axiosConfig';

const pilotReviewService = {
  getPilotReviews: async (pilotId) => {
    const response = await apiClient.get(`/pilot-reviews/pilot/${pilotId}/`);
    return response.data;
  },

  canReview: async (pilotId, missionId) => {
    try {
      const response = await apiClient.get(`/pilot-reviews/can-review/${pilotId}/${missionId}/`);
      return response.data;
    } catch (error) {
      return { can_review: false, reason: 'Error de conexión' };
    }
  },

  createReview: async (reviewData) => {
    try {
      const response = await apiClient.post('/pilot-reviews/', reviewData);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Error al enviar la reseña';
      throw new Error(errorMessage);
    }
  },

  getPilotStats: async (pilotId) => {
    try {
      const response = await apiClient.get(`/pilot-reviews/pilot/${pilotId}/`);
      const { reviews, average_rating, total_reviews } = response.data;
      return {
        average_rating: average_rating || 0,
        total_reviews:  total_reviews  || 0,
        recent_reviews: (reviews || []).slice(0, 3),
      };
    } catch (error) {
      return { average_rating: 0, total_reviews: 0, recent_reviews: [] };
    }
  },
};

export default pilotReviewService;
